import {ClickerPageLoader} from '@/ui/components/ClickerPageLoader/ClickerPageLoader';
import {Layout} from '@/ui/kit/Layout/Layout';
import {PreloaderCustom} from '@/ui/kit/PreloaderCustom/PreloaderCustom';

import s from './LoaderPage.module.css';

interface Props {
  showTabletBorders?: boolean;
}

export function LoaderPage({showTabletBorders = false}: Props): JSX.Element {
  if (showTabletBorders) {
    return <ClickerPageLoader />;
  }

  return (
    <Layout enableDiv100vh classNameMain={s.root}>
      <PreloaderCustom />
    </Layout>
  );
}
